import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '..'
import ButtonRounded from '../../ButtonRounded'
import { parseRemainingTimeString } from '../../../utils/stopResume'
import { ChevronIcon } from '../../icons'
import styles from './styles'

const StopResumeDialog = ({
  programmeName,
  remainingTime,
  onStartEpisode,
  onResumeEpisode,
}) => {
  const remainingTimeString = parseRemainingTimeString(remainingTime)

  const remainingTimeHint = [
    remainingTimeString && `${remainingTimeString} left`,
    'Would you like to continue?',
  ]
    .filter(Boolean)
    .join(' - ')

  return (
    <div className="StopResumeDialog">
      <Dialog
        title={`You started watching ${programmeName}`}
        subtitle={remainingTimeHint}
      />
      <div className="button-container">
        <div className="button-wrapper">
          <ButtonRounded
            theme="dark"
            text="Play from start"
            onClick={onStartEpisode}
            href="#"
            icon={
              <ChevronIcon />
            }
          />
        </div>
        <div className="button-wrapper">
          <ButtonRounded
            text="Resume"
            uppercase
            onClick={onResumeEpisode}
            href="#"
            icon={
              <ChevronIcon />
            }
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

StopResumeDialog.propTypes = {
  programmeName: PropTypes.string,
  remainingTime: PropTypes.number,
  onStartEpisode: PropTypes.func,
  onResumeEpisode: PropTypes.func,
}

StopResumeDialog.defaultProps = {
  programmeName: 'this programme',
  remainingTime: null,
  /* eslint-disable no-console */
  onStartEpisode: () => console.log('StopResumeDialog: no onStartEpisode func passed'),
  onResumeEpisode: () => console.log('StopResumeDialog: no onResumeEpisode func passed'),
  /* eslint-enable no-console */
}

export default StopResumeDialog
